import { render, staticRenderFns } from "./BoxScoreAggregator.vue?vue&type=template&id=2bcb22f8&scoped=true&"
import script from "./BoxScoreAggregator.vue?vue&type=script&lang=js&"
export * from "./BoxScoreAggregator.vue?vue&type=script&lang=js&"
import style0 from "./BoxScoreAggregator.vue?vue&type=style&index=0&id=2bcb22f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcb22f8",
  null
  
)

export default component.exports
import {QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection})
